import { useEffect, useState } from "react";

import { useTPRAFlow } from "./hooks/useTPRAFlow";
import { TPRAFormModal } from "./TPRAFormModal";
import { AssessmentExistsModal } from "./AssessmentExistsModal";
import { ArchiveWarningModal } from "./ArchiveWarningModal";
import type { TPRAAssessmentFlowProps } from "./types";

export function TPRAAssessmentFlow({
  isOpen,
  onClose,
  initialVendorData,
}: TPRAAssessmentFlowProps) {
  const {
    step,
    isLoading,
    existingAssessment,
    memberHasAccess,
    savedFormData,
    handleSubmit,
    handleViewAssessment,
    handleGoBack,
    handleStartNew,
    handleArchiveConfirm,
    reset,
  } = useTPRAFlow(onClose, initialVendorData);

  const [isArchiveConfirmed, setIsArchiveConfirmed] = useState(false);

  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      reset();
      setIsArchiveConfirmed(false);
    }
  }, [isOpen, reset]);

  // Form step
  if (step === "form") {
    return (
      <TPRAFormModal
        isOpen={isOpen}
        isSubmitting={isLoading}
        onClose={onClose}
        onSubmit={handleSubmit}
        initialData={savedFormData}
      />
    );
  }

  // Assessment exists step
  if (step === "exists" && existingAssessment) {
    return (
      <AssessmentExistsModal
        isOpen={true}
        assessment={existingAssessment}
        memberHasAccess={memberHasAccess}
        onClose={onClose}
        onBack={handleGoBack}
        onViewAssessment={handleViewAssessment}
        onStartNew={handleStartNew}
      />
    );
  }

  // Archive warning step
  if (step === "archive" && existingAssessment) {
    return (
      <ArchiveWarningModal
        isOpen={true}
        isConfirmed={isArchiveConfirmed}
        isLoading={isLoading}
        loadingText={isLoading ? "Creating assessment..." : undefined}
        onClose={onClose}
        onBack={handleGoBack}
        onToggleConfirm={setIsArchiveConfirmed}
        onProceed={handleArchiveConfirm}
      />
    );
  }

  return null;
}
